<template>
<div :class="primitiveBaseClasses">
    <label class="amf-input-label" v-if="$_showLabel">{{label}}</label>
    <textarea :class="['form-control', 'rounded-0', { error: hasError }]"
        v-model="internalValue"
        :rows="rows"
        :placeholder="placeholder"
        :disabled="$_disabled"
        :title="label"
        :autofocus="$_autofocus"></textarea>
    <div class="error-div">
        {{validationMessage}}
    </div>
</div>
</template>

<script>
import primitiveMixin from './primitive-mixin'

export default {
    mixins: [primitiveMixin],
    props: {
        label: {
            type: String,
            default: null,
            required: false
        },
        rows: {
            type: Number,
            default: 3,
            required: false
        },
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            internalValue: this.value,
        }
    },
    watch: {
        value(newValue) {
            this.internalValue = newValue;
        },
        internalValue(newValue) {
            this.changeMade({
                name: this.label,
                value: this.internalValue
            });
            this.$emit("input", newValue);
        },
    },
}
</script>




// WEBPACK FOOTER //
// src/framework/primitives/AmfTextarea.vue